import React from 'react';
import { PropTypes } from 'prop-types';
import Icon from '../../Icon';

var ServiceIconByServiceType = function ServiceIconByServiceType(_ref) {
  var qa = _ref.qa,
      className = _ref.className,
      serviceType = _ref.serviceType,
      size = _ref.size;

  // eslint-disable-next-line no-shadow
  var toServiceIcon = function toServiceIcon(serviceType) {
    switch (serviceType) {
      case 'PS_PLUS':
      /* falls through */

      case 'PS_PLUS_VAULT':
        return 'ps-plus';

      case 'PS_NOW':
        return 'ps-now';

      case 'EA_ACCESS':
      /* falls through */

      case 'EA_VAULT':
        return '3rd-party-ea';

      case 'UBISOFT_PLUS':
        return '3rd-party-ubisoft-plus';

      case 'GTA_PLUS':
        return '3rd-party-gta-plus';

      case 'NONE':
      /* falls through */

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(Icon, {
    qa: qa,
    className: className,
    size: size,
    type: toServiceIcon(serviceType)
  });
};

ServiceIconByServiceType.defaultProps = {
  qa: '',
  className: '',
  size: '1'
};
ServiceIconByServiceType.propTypes = {
  qa: PropTypes.string,
  className: PropTypes.string,
  // See: https://github.sie.sony.com/SIE-Private/arkham-gql/blob/28b71a3cbe0d765beb78f1e0595948a69acf7aa8/src/models/Catalog/enums.ts#L51-L58
  serviceType: PropTypes.string.isRequired,
  size: PropTypes.string
};
export default ServiceIconByServiceType;